// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VPopUp_wrapper_23NdL"};